import React, {useEffect, useState} from "react";
import { Link } from "react-router-dom";
import { Image, Space } from 'antd';
import { 
  AiOutlineEye,
  AiOutlineClose,
  AiOutlineRotateLeft,
  AiOutlineRotateRight,
  AiOutlineZoomIn, 
  AiOutlineZoomOut,
  AiOutlineSwap,
  AiOutlineArrowLeft,
  AiOutlineArrowRight,
  AiOutlineFilePdf
} from 'react-icons/ai';

const LeaveAttachment = ({fields, remove}) => {



  const handleDownloadAll = (data) => {
    
   
        if (!data || data.length === 0) {
            alert("No attachments available to download.");
            return;
          }
        
         
        
            // Create a temporary anchor element for downloading
            const link = document.createElement('a');
            link.href = data.url;
            link.target = "_blank";
        
            // Set file name or fallback to URL file name
            link.download = data.name || data.url.split('/').pop();
        
            // Trigger download
            document.body.appendChild(link);
            link.click();
        
            // Clean up the DOM
            document.body.removeChild(link);
         
 

  };


  return (
    <>
      <div className="tab-content">
        <div id="emp_profile" className="pro-overview tab-pane fade show active">            
          <div className="mail-attachments">
            <p>
                <i className="fa-solid fa-paperclip" /> {fields?.length} Attachments {" "}
          
            </p>
            <Image.PreviewGroup
          preview={{
            toolbarRender: (
              _,
              {
                transform: { scale },
                actions: {
                  onActive,
                  onFlipY,
                  onFlipX,
                  onRotateLeft,
                  onRotateRight,
                  onZoomOut,
                  onZoomIn,
                  onReset,
                  onClose
                },
              },
            ) => (
              <Space size={12} className="toolbar-wrapper">
                <AiOutlineArrowLeft onClick={() => onActive?.(-1)} />
                <AiOutlineArrowRight onClick={() => onActive?.(1)} />
                {/* <DownloadOutlined onClick={onDownload} /> */}
                <AiOutlineSwap rotate={90} onClick={onFlipY} />
                <AiOutlineSwap onClick={onFlipX} />
                <AiOutlineRotateLeft onClick={onRotateLeft} />
                <AiOutlineRotateRight onClick={onRotateRight} />
                <AiOutlineZoomOut disabled={scale === 1} onClick={onZoomOut} />
                <AiOutlineZoomIn disabled={scale === 50} onClick={onZoomIn} />
                <AiOutlineClose onClick={onClose} />
                {/* <AiOutlineUndo onClick={onReset} /> */}
              </Space>
            ),
            // onChange: (index) => {
            //   setCurrent(index);
            // },
          }}
        >
            <ul className="attachments clearfix">
            {fields?.length > 0 ? (
                    <>
                        {fields?.map((item, index) => (
                <ListItem
                id={item.id}
                key={index}
                item={item}
                download={handleDownloadAll}
                remove={remove}
                index={index}
                />
            ))}
                    </>
                    ) : (
                    <div></div>
                    )}

              

                
            </ul>
            </Image.PreviewGroup>
          </div>              
        </div>  

   
      </div>
      {/* Model Popup*/}

    </>
  );
};

export const ListItem = ({ item, key, remove, index }) => {
    console.log(index, "LLL")
    const isImage = ['jpg', 'jpeg', 'png', 'gif', 'webp'].includes(item?.url.split(".").pop().toLowerCase());

    return(
    <li>
    <div className="attach-file">
      {
        item?.url.split(".").pop() == "pdf" ?
          <i className="fa-solid fa-file-pdf"></i>
          : (
            isImage ? (
              <Image
                style={{ height: 40, width: 40, display: 'none' }}
                src={item.url}
                alt=""
                preview={{
                  src: item.url,
                  mask: null,
                }}
              />
            ) : (
              <img style={{ height: 40, width: 40 }} src={item.url} alt="" />
            )
          )
      }
        {
          isImage ? (
            <img style={{ height: '100px'}} src={item.url} alt="" />
          ) : (
            <></>
          )
        }
        
    </div>
    <div className="attach-info align-right d-flex justify-content-end ">
    <Link  className="attach-filename" onClick={() => {
      if(isImage){
        // Find the corresponding Image component and trigger its preview
        document.querySelector(`[src="${item.url}"]`)?.click();
      }else{
        window.open(item.url, "_blank");
      }
            }} >
           <i className="attach-fileize fa-solid fa-eye me-2"/>
        </Link>
        {" "}
        <Link  className="attach-filename" onClick={() => remove(index)}  >
           <i className="attach-fileize fa-solid fa-trash"/>
        </Link>{" "}      
    </div>
</li>
  )};

export default LeaveAttachment;
